import { Component, Output, EventEmitter, Input, OnInit } from '@angular/core';
import { GameState } from '../../interfaces/game.interface';
import { DataService } from '../../services/data.service';

@Component({
  selector: 'app-news-page',
  templateUrl: './news-page.component.html',
  styleUrls: ['./news-page.component.scss']
})
export class NewsPageComponent implements OnInit {
  @Output() closeClick = new EventEmitter<void>();
  game_state: GameState | null = null;
  news: string[] = [];

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.game_state = this.dataService.getGameStateSnapshot();
    const currentState = this.game_state.game_state;
    const newsEntries = this.game_state.news ? this.game_state.news[currentState] : null;
      
    this.news = Array.isArray(newsEntries) 
      ? newsEntries 
      : ['No news available for current quarter'];
  }

  onCloseClick(): void {
    this.closeClick.emit();
  }
}
